import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(({ theme }) =>
  css({
    mt: `${theme.space.xl}px`,
    mb: `${theme.space.l}px`,
    pb: `${theme.space.default}px`,
    backgroundColor: 'grey.5',
    border: '1px solid',
    borderColor: 'grey.1',
    borderRadius: '3px',
    height: '100%',
  }),
);

themeStyles.addBaseStyles('FilterContainer')(({ theme }) =>
  css({
    px: `${theme.space.default}px`,
    pt: 'm',
    justifyContent: 'space-between',
    display: 'flex',
  }),
);

themeStyles.addBaseStyles('MobileFilterContainer')(
  css({
    backgroundColor: 'grey.5',
    pl: 's',
    mt: 'l',
    border: '1px solid',
    borderColor: 'grey.1',
    borderRadius: '2px',
  }),
);

themeStyles.addBaseStyles('CheckboxContainer')(
  css({
    display: 'flex',
    flexDirection: ['column', 'row'],
    gap: ['10px', 'l'],
    px: [0, 0, 'default'],
    pt: [0, 0, 'm'],
    mb: ['s', 's', 0],
  }),
);

themeStyles.addBaseStyles('FilterCheckboxContainer')(
  css({
    display: 'flex',
    alignItems: ['start', 'center'],
    gap: 'xs',
  }),
);

themeStyles.addBaseStyles('AccordionTitleContainer')(
  css({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  }),
);

themeStyles.addBaseStyles('AccordionContentContainer')(
  css({
    display: 'flex',
    flexDirection: 'row',
    pb: 's',
    gap: '20px',
    pr: 's',
    width: '100%',
  }),
);

themeStyles.addBaseStyles('VehicleFilterTitle')(
  css({
    fontFamily: 'bold',
    fontSize: '14px',
    lineHeight: 'sm',
    width: 'calc(60% + 20px)',
  }),
);

themeStyles.addBaseStyles('YearFilterTitle')(
  css({
    pl: 's',
    fontFamily: 'bold',
    fontSize: '14px',
    lineHeight: 'sm',
    width: '40%',
  }),
);

themeStyles.addBaseStyles('FilterItem')(
  css({
    position: 'relative',
    backgroundColor: 'grey.5',
    border: 'none',
    height: '100%',
    ':after': {
      content: '""',
      height: '1px',
      backgroundColor: 'grey.2',
      position: 'absolute',
      bottom: '-1px',
      left: 0,
      width: 0,
      transition: 'all',
      transitionDuration: 't5',
      transitionTimingFunction: 'default',
    },
  }),
  ({ theme, isActive, isDisabled, isFilterItemBold }) =>
    css({
      padding: 'zero',
      '&:hover': {
        borderBottom: !isDisabled && `${theme.borders[1]} ${theme.colors.black}`,
      },
      height: '100%',
      borderBottom: isActive && `${theme.borders[1]} ${theme.colors.black}`,
      cursor: !isDisabled && 'pointer',
      '& p': {
        color: isDisabled && 'grey.0',
      },
      p: {
        fontFamily: isFilterItemBold ? 'bold' : 'default',
      },
    }),
);

export default themeStyles;
